export const queryKeys = {
  CITY_ORGANIZATION: "city-organization",
  CITY_DETAILED_ORGANIZATION: "city-detailed-organization",
  CITY_ORGANIZATION_SELECT: "city-organization-select",
  CITY_TAGS: "city-tags",
}
